// extracted by mini-css-extract-plugin
export default {"actionButtonStyle":"ChangeContactPhoneCard_actionButtonStyle__OKxwf","form":"ChangeContactPhoneCard_form__Pt70P","gridContainer":"ChangeContactPhoneCard_gridContainer__ZR0Mr"};